import { showNotification } from "@/lib/notifications";
import { environment } from "@/lib/resources";

// zeigt Notifications an, die vom Server generiert wurden
let notification = environment.notification;
window.setTimeout(() => {
	if (notification) {
		showNotification(notification.style, notification.message, notification.duration);
	}
}, 100);
